import { NgxIndexedDBModule } from "ngx-indexed-db";
import { NgxSpinnerModule } from "ngx-spinner";
import { AccordionModule } from "primeng/accordion";
import { MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";

import { CommonModule, CurrencyPipe, DatePipe, registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import localeFrExtra from "@angular/common/locales/extra/fr";
import localeFr from "@angular/common/locales/fr";
import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Router, RouterModule, TitleStrategy } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgIconsModule, provideNgIconsConfig } from "@ng-icons/core";
import * as Sentry from "@sentry/angular";

import { environment } from "../environments/environment";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app.routing";
import { CoreModule } from "./core/core.module";
import { EvaTitleStrategy } from "./core/strategies/eva-title.strategy";
import { AppConfigService } from "./core/services/app-config.service";
import { AuthInterceptor } from "./helpers/auth.interceptor";
import { ErrorInterceptor } from "./helpers/error.interceptor";
import { GlobalErrorHandler } from "./helpers/global-error-handler";
import { dbConfig } from "./indexed-db.config";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";
import { EvaConfirmDialogComponent } from "./shared/ds/eva-confirm-dialog/eva-confirm-dialog.component";
import { APP_ICONS } from "./shared/ds/icons/app-icons";
import { JsonDateInterceptor } from "./services/json-date-interceptor";

// Quill.register("modules/imageResize", ImageResize);

registerLocaleData(localeFr, "fr", localeFrExtra);

export function initializeApp(appConfigService: AppConfigService) {
  return () => appConfigService.loadAppConfig();
}

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    AppRoutingModule,
    NgxSpinnerModule,
    RouterModule,
    AccordionModule,
    ToastModule,
    EvaConfirmDialogComponent,
    NgxIndexedDBModule.forRoot(dbConfig),
    // Fournit le Icons Token au niveau racine pour les DS standalone components qui importent NgIconsModule
    NgIconsModule.withIcons(APP_ICONS),
  ],
  declarations: [AppComponent, AuthLayoutComponent],
  providers: [
    ...provideNgIconsConfig({
      size: "1.25em",
    }),
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService],
      multi: true,
    },
    { provide: DEFAULT_CURRENCY_CODE, useValue: "CHF" },
    { provide: LOCALE_ID, useValue: "fr" }, //your locale
    { provide: HTTP_INTERCEPTORS, useClass: JsonDateInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: DatePipe },
    { provide: CurrencyPipe },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    MessageService,
    { provide: TitleStrategy, useClass: EvaTitleStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(trace: Sentry.TraceService) {}
}
